import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export const Layout = () => (
  <div className="min-h-screen bg-[#0A0E0D] text-[#F4F4F0] flex flex-col">
    <Navbar />
    <div className="flex-1 pt-16">
      <Outlet />
    </div>
    <Footer />
  </div>
);
